import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 31"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F67B2D",
      d: "M31.8 27.6H18.2V3.3h13.6z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#EE3332",
      d: "M19.1 15.5c0-4.7 2.2-9.2 5.9-12.1C22.3 1.2 19 0 15.5 0 6.9 0 0 6.9 0 15.5S6.9 31 15.5 31c3.5 0 6.8-1.2 9.5-3.4-3.7-2.9-5.9-7.4-5.9-12.1"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FCAD20",
      d: "M50 15.5C50 24.1 43.1 31 34.5 31c-3.5 0-6.8-1.2-9.5-3.4 6.7-5.3 7.8-14.9 2.6-21.6-.8-1-1.6-1.8-2.6-2.6C27.7 1.2 31 0 34.5 0 43.1 0 50 6.9 50 15.5"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "mastercard"}) } }